var _youtubeNoJsLink = '.js-youtube-play';
var _$youtubeNoJsLink = $(_youtubeNoJsLink);
var _youtubePlayers = '.js-youtube-player';
var _$youtubePlayers = $(_youtubePlayers);

var _params = {
	playingClass: 'is-playing'
};

if (_$youtubePlayers.length) {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onYouTubeIframeAPIReady() {

	_$youtubePlayers.each(function(i, youtubePlayer) {

		var $youtubePlayer = $(youtubePlayer);

		var params = {};
		var defaults = {
			height: '720',
			width: '1280',
			videoId: $(this).data('video'),
			playerVars: {
				'rel': 0,
				'showinfo': 0,
				'color': 'white'
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		};
		var autoplay = ( $youtubePlayer.hasClass('autoplay') ) ? true : false;
		var autoplayOptions = {};

		if( autoplay ) {
			autoplayOptions = {
				playerVars: {
					'autoplay': 1
				}
			};
		}

		params = $.extend(true, defaults, autoplayOptions);

		/**
		 * Using `$youtubePlayer` instead of `$(this)[0]`
		 * doesn't work.
		 */
		var player = new YT.Player($(this)[0], params);

		function onPlayerReady() {
			var $youtubePlay = $(player.a).closest('.js-youtube-play');
			if ( autoplay ) {
				player.mute();
				$youtubePlay.addClass(_params.playingClass);
			}
			$youtubePlay.on('click', function(e) {
				e.preventDefault();
				$(this).addClass(_params.playingClass);
				player.playVideo();
			});
		}

		function onPlayerStateChange(event) {
			if (event.data === 0) {
				$(event.target.a).closest(_youtubeNoJsLink).removeClass(_params.playingClass);
			}
		}
	});

}
